import React from 'react'
import { Spinner } from "@lysaab/ui-2";
import { FormattedMessage } from "react-intl";

export const OnfidoPending: React.VFC = () => {
  return (
    <div className="pending-container">
      <Spinner />
      <div>
        <FormattedMessage id="onfido.status.poa.waiting_for_onfido_automatic_review" />
      </div>
    </div>
  );
};
